<!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->

<ngx-spinner [bdColor]="'rgba(0, 0, 0, 0.5)'" [size]="'medium'" [color]="'#fff'" [type]="'custom'"
    [fullScreen]="true">
    <div class="dotted-loader"></div>
</ngx-spinner>


<ng-container *ngIf="underMaintance">
    <app-under-mainatance></app-under-mainatance>
</ng-container>
<ng-container *ngIf="!underMaintance">
    <router-outlet>
    </router-outlet>
</ng-container>